import { render, staticRenderFns } from "./BusinessTeams.vue?vue&type=template&id=21193ae8"
import script from "./BusinessTeams.vue?vue&type=script&lang=js"
export * from "./BusinessTeams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports